import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClienteFichaResumoJanelaComponent } from './cliente-ficha-resumo-janela.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: ClienteFichaResumoJanelaComponent}
  ])],
  exports: [RouterModule]
})
export class ClienteFichaResumoJanelaRoutingModule { }
